var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, PacemEventTarget, Watch, PropertyConverters, Utils } from './_default-imports';
//namespace Pacem.Components {
let PacemHtmlProxyElement = class PacemHtmlProxyElement extends PacemEventTarget {
    constructor() {
        super(...arguments);
        this._html = document.documentElement;
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (name === 'attr' && old) {
            this._html.removeAttribute(old);
        }
        this._update();
    }
    _update() {
        const key = this.attr;
        if (Utils.isNullOrEmpty(key) || this.disabled) {
            // No key means do nothing
            return;
        }
        const value = this.value;
        const html = this._html;
        if (Utils.isNullOrEmpty(value)) {
            html.removeAttribute(key);
        }
        else {
            html.setAttribute(key, value);
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemHtmlProxyElement.prototype, "attr", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemHtmlProxyElement.prototype, "value", void 0);
PacemHtmlProxyElement = __decorate([
    CustomElement({
        tagName: P + '-html-proxy'
    })
], PacemHtmlProxyElement);
export { PacemHtmlProxyElement };
//}
